import { useBookEditor } from "./BookEditorProvider";

/** Turn 1 stub — Write/Canvas own left docks. */
export default function BookEditorLeftPanel() {
  const { mode, chapters, activeChapterId, setActiveChapterId } = useBookEditor();
  if (mode === "write" || mode === "canvas") return null;
  return (
    <aside className="book-editor-left-panel" data-testid="book-editor-left-panel">
      <h3>Chapters</h3>
      <ul>
        {(chapters || []).map((ch) => (
          <li key={ch.id}>
            <button
              type="button"
              className={ch.id === activeChapterId ? "is-active" : ""}
              onClick={() => setActiveChapterId(ch.id)}
            >
              {ch.title || ch.id}
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
}
